import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";

export function InstallAppButton() {
  const [prompt, setPrompt] = useState(null);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const standalone =
      window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (standalone) {
      setHidden(true);
      return;
    }
    const onPrompt = (e) => {
      e.preventDefault();
      setPrompt(e);
    };
    const onInstalled = () => setHidden(true);
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (hidden) return null;

  const isIOS = /iphone|ipad|ipod/i.test(window.navigator.userAgent);

  const install = async () => {
    if (prompt) {
      prompt.prompt();
      const { outcome } = await prompt.userChoice;
      if (outcome === "accepted") setHidden(true);
      setPrompt(null);
    } else if (isIOS) {
      toast.info("To install: tap the Share icon, then 'Add to Home Screen'.");
    } else {
      toast.info("Open your browser menu (⋮) and choose 'Install app' / 'Add to Home screen'.");
    }
  };

  return (
    <button
      data-testid="install-app-btn"
      onClick={install}
      className="flex items-center gap-1.5 h-9 px-3 md:px-4 rounded-full bg-primary text-white text-sm font-bold hover:bg-primary/90 transition-colors shrink-0"
    >
      <Download className="h-4 w-4" />
      <span className="hidden sm:inline">Get app</span>
    </button>
  );
}
